import isEmpty from "lodash/isEmpty";

import BookingCalendar from "@components/Booking/BookingCalendar/BookingCalendar";
import BookingCalendarDrawer from "@components/Booking/BookingCalendarDrawer/BookingCalendarDrawer";
import Footer from "@components/footer/Footer";
import IdleWarningModal from "@components/Kiosk/IdleWarningModal/IdleWarningModal";
import ReservationDetails from "@components/User/Reservations/ReservationDetails/ReservationDetails";
import { LocationContext } from "@contexts/location/LocationContext";
import { useKioskBooking } from "@hooks/useKioskBooking/useKioskBooking";
import { locationType } from "@models/services/organisation";

import CalendarHeader from "../CalendarHeader/CalendarHeader";
import Header from "../Header/Header";
import KioskButtonComponent from "../KioskButtonComponent/KioskButtonComponent";
import UserLogin from "../UserLogin/UserLogin";

export default function KioskBookingPage() {
  const {
    activeLocation,
    bookingLoader,
    bookingSlots,
    bookingSuccessDetails,
    getBookingSlots,
    handleContinueSession,
    handleLocationChange,
    hideSuccessModal,
    locationDetails,
    paymentLoader,
    priceLoader,
    remainingTime,
    showWarning,
    userProfile,
  } = useKioskBooking();

  return (
    <LocationContext.Provider
      value={{
        activeLocation: activeLocation as locationType,
        contactPersonDetails: undefined,
        locationDetails,
        paymentRef: null,
        pricingRef: null,
        userProfile,
      }}
    >
      <div className="kiosk-booking-page-wrapper d-flex flex-column">
        <Header
          isLoading={isEmpty(locationDetails)}
          logoImage={locationDetails?.mobileLogo || undefined}
        />
        <div className="container-fluid mt-3 flex-grow-1">
          {locationDetails && (
            <CalendarHeader
              locationDetails={locationDetails}
              selectedTab={activeLocation?.id}
              onTabChange={handleLocationChange}
            />
          )}

          {bookingSlots && (
            <BookingCalendar
              slots={bookingSlots}
              bookingLoader={bookingLoader}
              locationId={bookingSlots.locationId}
              refreshResources={getBookingSlots}
            />
          )}
        </div>

        {activeLocation?.id && (
          <BookingCalendarDrawer
            checkBookingDisable={() => paymentLoader}
            bookingSlots={bookingSlots}
            locationContext={activeLocation as locationType}
            priceLoader={priceLoader}
          />
        )}

        <UserLogin slotInfo={bookingSlots} />

        {/* Idle Warning Modal */}
        <IdleWarningModal
          isOpen={showWarning}
          remainingTime={remainingTime}
          onContinue={handleContinueSession}
        />

        {bookingSuccessDetails.bookingId && (
          <ReservationDetails
            bookingData={{
              bookingId: bookingSuccessDetails.bookingId,
            }}
            isOpen={bookingSuccessDetails.showModal}
            toggleCancelModal={() => hideSuccessModal()}
            toggleOpen={() => hideSuccessModal()}
            showCancelSection={false}
            isKiosk={true}
            kioskButtonComponent={
              <KioskButtonComponent hideSuccessModal={hideSuccessModal} />
            }
          />
        )}

        <div className="mt-2">
          <Footer />
        </div>
      </div>
    </LocationContext.Provider>
  );
}
